import { Link } from 'react-router-dom';
import { useCart } from '../../hooks/useCart';
import { Button } from '../ui/Button';
import { formatCurrency } from '../../lib/formatCurrency';

export function CartDrawer() {
  const { items, removeItem, updateQuantity, total } = useCart();

  if (items.length === 0) {
    return (
      <div className="py-12 text-center">
        <svg className="mx-auto h-12 w-12 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
        </svg>
        <p className="mt-4 text-gray-500">Your cart is empty</p>
        <Link to="/" className="mt-4 inline-block text-sm text-green-500 hover:text-green-400">
          Browse products
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {items.map((item) => (
        <div key={item.productId} className="flex items-center gap-4 rounded-lg border border-white/10 bg-navy-900/30 p-3">
          <div className="h-16 w-16 flex-shrink-0 rounded-lg bg-navy-800 overflow-hidden">
            {item.thumbnailUrl ? (
              <img src={item.thumbnailUrl} alt={item.name} className="h-full w-full object-cover" />
            ) : (
              <div className="flex h-full items-center justify-center text-gray-600">
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>
              </div>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <Link to={`/product/${item.slug}`} className="text-sm font-medium text-white hover:text-green-400 truncate block">
              {item.name}
            </Link>
            <p className="text-sm text-green-400">{formatCurrency(item.price)}</p>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={() => updateQuantity(item.productId, item.quantity - 1)} className="h-7 w-7 rounded border border-white/10 text-gray-400 hover:text-white hover:border-white/30 transition-colors">-</button>
            <span className="w-6 text-center text-sm text-white">{item.quantity}</span>
            <button onClick={() => updateQuantity(item.productId, item.quantity + 1)} className="h-7 w-7 rounded border border-white/10 text-gray-400 hover:text-white hover:border-white/30 transition-colors">+</button>
          </div>
          <button onClick={() => removeItem(item.productId)} className="text-gray-500 hover:text-red-400 transition-colors">
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
      ))}

      <div className="border-t border-white/10 pt-4">
        <div className="flex justify-between text-lg font-semibold">
          <span className="text-white">Total</span>
          <span className="text-green-400">{formatCurrency(total)}</span>
        </div>
      </div>
    </div>
  );
}
